// src/api/courseService.js
import apiClient from "./apiClient";

// 🔹 Get all courses (optionally with filters like ?limit=10)
export const getCourses = async (params = {}) => {
  const response = await apiClient.get("/courses/", { params });
  return response.data;
};

// 🔹 Get a single course by ID
export const getCourseById = async (id) => {
  const response = await apiClient.get(`/courses/${id}`);
  return response.data;
};

// 🔹 Create a new course
export const createCourse = async (data) => {
  const response = await apiClient.post("/courses/", data);
  return response.data;
};

// 🔹 Update an existing course
export const updateCourse = async (id, data) => {
  const response = await apiClient.put(`/courses/${id}`, data);
  return response.data;
};

// 🔹 Delete a course
export const deleteCourse = async (id) => {
  const response = await apiClient.delete(`/courses/${id}`);
  return response.data;
};

// ✅ Get all courses that belong to a specific program
export const getCoursesByProgram = async (programId) => {
  const response = await apiClient.get(`/courses/by_program/${programId}`);
  return response.data;
};

// ✅ Get all courses that belong to a specific semester
export const getCoursesBySemester = async (semesterId) => {
  const response = await apiClient.get(`/courses/by_semester/${semesterId}`);
  return response.data;
};
